module.exports = __webpack_public_path__ + "img/icon_twitter.svg?version=fe9c5492";